module.exports = __webpack_public_path__ + "6af93742bcc0fd337a94daa9741fcee3.png";